import * as _ from "lodash";
import { useMappedState } from "redux-react-hook";
import * as React from "react";

import type { IRoute } from "src/pages/Router/routes";
import type { IStore } from "src/core/shared/store/index";

const useCanAccessRoute: () => (route: IRoute) => boolean = () => {
  const store = useMappedState((store: IStore) => store);
  const erp = store.global.settings && store.global.settings.erp.name;
  const installedModules = (store.global.settings && store.global.settings.installedModules) || [];
  const role = store.global.role;

  const canAccessRoute = React.useCallback(
    (route: IRoute) => {
      if (route && erp) {
        const permRequired = route.permissions ? route.permissions.length : 0;
        let permMatch = 0;

        // check route is private
        if (route.privateRoute) {
          if (route.erp && !_.includes(route.erp, erp)) {
            return false;
          }

          if (route.modules) {
            for (const moduleName of route.modules) {
              if (!installedModules.includes(moduleName)) {
                return false;
              }
            }
          }

          // check we have a role and role type
          if (role && role.type) {
            // if the route is role specific then check the role has accedd
            if (route.roles) {
              if (!_.includes(route.roles, role.type)) {
                return false;
              }
            }

            // continue to check permissions
            _.each(route.permissions, perm => {
              if (_.includes(_.map(role.permissions, rolePerm => rolePerm.code), perm)) {
                permMatch++;
              }
            });

            // if the role has all the permissions allow
            if (permMatch !== permRequired) {
              return false;
            }
          }

          if (route.canView) {
            return route.canView(store);
          }

          return true;
        } else {
          return true;
        }
      }

      return false;
    },
    [
      erp,
      installedModules,
      role
    ]
  );

  return canAccessRoute;
};

export default useCanAccessRoute;
